import { AbstractStorageService } from 'huddyapi';
import { Injectable, Inject } from '@angular/core';
import { LocalStorageService, SessionStorageService } from '@efaps/ngx-store';


@Injectable({
    providedIn: 'root'
})
export class DesktopStorageService extends AbstractStorageService {

    constructor(private storage: LocalStorageService,
                private sessionStorage: SessionStorageService){
        super();
    }

    async set(key : string, value : string, local: boolean = true) {
        if(local) {
            this.storage.set(key, value);
            this.sessionStorage.remove(key);
        } else {
            this.sessionStorage.set(key, value);
            this.storage.remove(key);
        }
    };

    async get(key : string)  {
        const session = this.sessionStorage.get(key);
        if(session != null)
            return session;
        return this.storage.get(key)
    };

    async remove(key: string) {
        this.sessionStorage.remove(key);
        this.storage.remove(key);
    };

    async removeKeyStartsWith(keyPrefix : string) {
        let keys = this.storage
        for (let key in keys){
            console.log(key);
        }
    }

    clear() {
        this.storage.clear();
        this.sessionStorage.clear();
    }
}
